import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import HLIconButton from "../../shared/components/icon-button/HLIconButton";
import ArrowBackIcon from "../../shared/styles/icons/ArrowBackIcon";
import FullPageLoader from "../../shared/components/full-page-loader/FullPageLoader";
import AgreementInfoCard from '../../components/agreement/info/AgreementInfoCard';
import AgreementLessonsCard from '../../components/agreement/lessons/AgreementLessonsCard';
import classes from "./AgreementPage.module.scss";
import {AgreementStructure} from "../../shared/types/agreement";
import {loadAgreementByIdFetch} from "../../app/axios/agreementFetches";

const AgreementPage = () => {
    const {id} = useParams();
    const {state} = useLocation();

    const [agreement, setAgreement] = useState<AgreementStructure | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!state) loadAgreement();
        else setAgreement(state)
    }, [id]);

    const loadAgreement = () => loadAgreementByIdFetch(Number(id))
        .then(agreement => setAgreement(agreement))

    if (!agreement) {
        return <FullPageLoader/>;
    }

    const onBack = () => navigate('/agreements');

    return (
        <div className="pageContainer">
            <div className="columnContainer">
                <HLIconButton
                    icon={<ArrowBackIcon/>}
                    onClick={onBack}
                    aria-label="Назад к договорам"
                />
                <div className="inlineContainer">
                    <div className={classes.leftContainer}>
                        <AgreementInfoCard
                            agreement={agreement}
                            setAgreement={setAgreement}
                        />
                    </div>

                    <div className={classes.rightContainer}>
                        <AgreementLessonsCard
                            agreement={agreement}
                            loadAgreement={loadAgreement}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgreementPage; 